import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router';
import {
    message
} from 'ant-design-vue';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: localStorage.getItem("token") ? localStorage.getItem("token") : '',
        userinfo: null,
        menuRouter: null,
        buttonPower: null
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setUserinfo(state, value) {
            state.userinfo = value
        },
        setMenuRouter(state, value) {
            state.menuRouter = value
        },
        setButtonPower(state, value) {
            state.buttonPower = value
        },
    },
    actions: {

        LoginOk({
            commit
        }, token) {
            if (token) {
                commit("setToken", token)
                localStorage.setItem("token", token)
            }
        },
        Loginout({
            commit
        }) {
            commit("setToken", "")
            commit("setUserinfo", null)
            commit("setMenuRouter", null)
            commit("setButtonPower", null)
            localStorage.removeItem("token")
            message.success("退出登录成功")
            router.replace("/sign-in")
        }
    },
    getters: {
        userinfo: (state) => state.userinfo,
        menuRouter: (state) => state.menuRouter
    },
});